import { Routes } from '@angular/router';
import { canActivateAuthRole } from './guards/auth-guard';
import { ForbiddenComponent } from './core/components/forbidden/forbidden.component';
import { NotFoundComponent } from './core/components/not-found/not-found.component';
import { eKomunikacijaGuard, settingsGuard } from './guards/settings-guard';
import { adminRoutes } from './feature/admin/admin.routes';

export const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  {
    path: '',
    loadComponent: () =>
      import('./core/layouts/layout/layout.component').then(
        (m) => m.LayoutComponent,
      ),
    children: [
      {
        path: 'home',
        loadComponent: () =>
          import('./core/components/home/home.component').then(
            (m) => m.HomeComponent,
          ),
      },
      {
        path: 'case-details',
        loadComponent: () =>
          import('./feature/uvid-u-predmete/uvid-u-predmete.component').then(
            (m) => m.UvidUPredmeteComponent,
          ),
        canActivate: [canActivateAuthRole, settingsGuard],
        data: { role: 'uvid_u_predmete' },
      },
      {
        path: 'digital-signing',
        loadComponent: () =>
          import('./feature/digitalno-potpisivanje/digitalno-potpisivanje.component').then(
            (m) => m.DigitalnoPotpisivanjeComponent,
          ),
        canActivate: [canActivateAuthRole, settingsGuard],
        data: { role: 'digitalno_potpisivanje' },
      },
      {
        path: 'proposal-creation',
        loadComponent: () =>
          import('./feature/kreiranje-prijedloga/kreiranje-prijedloga.component').then(
            (m) => m.KreiranjePrijedlogaComponent,
          ),
        canActivate: [canActivateAuthRole, settingsGuard],
        data: { role: 'kreiranje_prijedloga' },
      },
      {
        path: 'send-to-court',
        loadComponent: () =>
          import('./feature/slanje-na-sud/slanje-na-sud.component').then(
            (m) => m.SendToCourtComponent,
          ),
        canActivate: [canActivateAuthRole, settingsGuard],
        data: { role: 'slanje_na_sud' },
      },
      {
        path: 'preuzimanje-poste',
        loadComponent: () =>
          import('./feature/preuzimanje-poste/preuzimanje-poste.component').then(
            (m) => m.PreuzimanjePosteComponent,
          ),
        canActivate: [canActivateAuthRole, eKomunikacijaGuard],
        data: { role: 'preuzimanje_poste' },
      },
      {
        path: 'formiranje-obrazaca',
        loadComponent: () =>
          import('./feature/formiranje-obrazaca/formiranje-obrazaca.component').then(
            (m) => m.FormiranjeObrazacaComponent,
          ),
        canActivate: [canActivateAuthRole, eKomunikacijaGuard],
        data: { role: 'formiranje_obrazaca' },
      },
      {
        path: 'pregled-predmeta',
        loadComponent: () =>
          import('./feature/pregled-predmeta/pregled-predmeta.component').then(
            (m) => m.PregledPredmetaComponent,
          ),
        canActivate: [canActivateAuthRole, settingsGuard],
        data: { role: 'pregled_predmeta' },
      },
      {
        path: 'request-creation',
        loadComponent: () =>
          import('./feature/kreiranje-zahtjeva/kreiranje-zahtjeva.component').then(
            (m) => m.KreiranjeZahtjevaComponent,
          ),
        canActivate: [canActivateAuthRole, settingsGuard],
        data: { role: 'zahtjevi_kreiranje_zahtjeva' },
      },
      {
        path: 'pregled-zahtjeva',
        loadComponent: () =>
          import('./feature/pregled-zahtjeva/pregled-zahtjeva.component').then(
            (m) => m.PregledZahtjevaComponent,
          ),
        canActivate: [canActivateAuthRole, settingsGuard],
        data: { role: 'zahtjevi_pregled_zahtjeva' },
      },
      {
        path: 'potpisivanje-zahtjeva',
        loadComponent: () =>
          import('./feature/potpisivanje-zahtjeva/potpisivanje-zahtjeva.component').then(
            (m) => m.PotpisivanjeZahtjevaComponent,
          ),
        canActivate: [canActivateAuthRole, settingsGuard],
        data: { role: 'zahtjevi_potpisivanje_zahtjeva' },
      },
      {
        path: 'slanje-na-finu',
        loadComponent: () =>
          import('./feature/slanje-na-finu/slanje-na-finu.component').then(
            (m) => m.SlanjeNaFinuComponent,
          ),
        canActivate: [canActivateAuthRole, settingsGuard],
        data: { role: 'zahtjevi_slanje_fina' },
      },
      {
        path: 'slanje-podnesaka',
        loadComponent: () =>
          import('./feature/slanje-podnesaka/slanje-podnesaka.component').then(
            (m) => m.SlanjePodnesakaComponent,
          ),
        canActivate: [canActivateAuthRole, eKomunikacijaGuard],
        data: { role: 'slanje_podnesaka' },
      },
      {
        path: 'slanje-troskova-na-sud',
        loadComponent: () =>
          import('./feature/slanje-troskova-na-sud/slanje-troskova-na-sud.component').then(
            (m) => m.SlanjeTroskovaNaSudComponent,
          ),
        canActivate: [canActivateAuthRole, eKomunikacijaGuard],
        data: { role: 'slanje_troskova' },
      },
      { path: 'forbidden', component: ForbiddenComponent },
    ],
  },
  ...adminRoutes,
  { path: '**', component: NotFoundComponent },
];
